import * as _ from "lodash";

import { Table } from "./table";

import {
  TableColumnData,
  TableColumnHeader,
  TableColumnFormatter,
  TableColumnInputData,
  TableColumnLink,
  TableButtonData,
  TableStringFunction
} from "../table.interface";

export class TableColumn {
  constructor(private _columnData: TableColumnData, private _table: Table) {}

  private _header: TableColumnHeader;
  private _sorted: boolean;
  private _sort_icon: string;

  public get header(): TableColumnHeader {
    return this._header;
  }

  public get accessor(): string {
    return this._columnData.accessor;
  }
  public set accessor(accessor: string) {
    this._columnData.accessor = accessor;
  }

  public get sortable(): boolean {
    return this._columnData.sortable;
  }
  public set sortable(sortable: boolean) {
    this._columnData.sortable = sortable;
  }

  public get truncate(): boolean {
    return this._columnData.truncate;
  }
  public set truncate(truncate: boolean) {
    this._columnData.truncate = truncate;
  }

  public get numeric(): boolean {
    return this._columnData.numeric;
  }
  public set numeric(numeric: boolean) {
    this._columnData.numeric = numeric;
  }

  public get html(): boolean {
    return this._columnData.html;
  }
  public set html(html: boolean) {
    this._columnData.html = html;
  }

  public get width(): string {
    return this._columnData.width;
  }
  public set width(width: string) {
    this._columnData.width = width;
  }

  public get format(): TableColumnFormatter {
    return this._columnData.format;
  }
  public set format(format: TableColumnFormatter) {
    if (_.isFunction(format)) {
      this._columnData.format = format;
    }
  }

  public get title(): TableColumnFormatter {
    return this._columnData.title;
  }
  public set title(title: TableColumnFormatter) {
    this._columnData.title = title;
  }

  public get buttons(): Array<TableButtonData> {
    return this._columnData.buttons;
  }
  public set buttons(buttons: Array<TableButtonData>) {
    this._columnData.buttons = buttons;
  }

  public get input(): TableColumnInputData {
    return this._columnData.input;
  }
  public set input(input: TableColumnInputData) {
    this._columnData.input = input;
  }

  public get link(): TableColumnLink {
    return this._columnData.link;
  }
  public set link(link: TableColumnLink) {
    this._columnData.link = link;
  }

  public get selectable(): boolean {
    return this._columnData.selectable;
  }
  public set selectable(selectable: boolean) {
    this._columnData.selectable = selectable;
  }

  public get sorted(): boolean {
    return this._sorted;
  }

  public get sort_icon(): string {
    return this._sort_icon;
  }

  public update() {
    this._setHeader();
    this._setSorted();
  }

  private _setHeader() {
    let label = null;
    let title = null;

    if (!this._columnData.header) {
      this._columnData.header = {};
    }

    if (_.isFunction(this._columnData.header.label)) {
      label = (<TableStringFunction>this._columnData.header.label)(null);
    } else if (_.isString(this._columnData.header.label)) {
      label = <string>this._columnData.header.label;
    } else {
      label = null;
    }

    if (_.isFunction(this._columnData.header.title)) {
      title = (<TableStringFunction>this._columnData.header.title)(null);
    } else if (_.isString(this._columnData.header.title)) {
      title = <string>this._columnData.header.title;
    } else {
      title = null;
    }

    this._header = {
      label: label,
      title: title || label
    };
  }

  private _setSorted() {
    this._sorted = this.accessor == this._table.sort.accessor;

    this._setSortIcon();
  }

  private _setSortIcon() {
    this._sort_icon = this._sorted ? this._table.getSortIcon(this) : "sort";
  }
}
